// Frontend email config - do NOT store SMTP credentials here.
// Use Vite env variable `VITE_TO_EMAIL` to configure the displayed contact email.
export const emailConfig = {
  toEmail: import.meta.env.VITE_TO_EMAIL || 'Info@bdowur.com'
};
